import zod from 'zod';

export type RelationRef = {
  _v: 1;
  docId: string;
  blockId: string;
};

export type RelationRawValue = RelationRef[];

export type RelationPropertyData = {
  _v: 1;
  targetDocId: string | null;
  targetBlockId: string | null;
  pairedColumnId: string | null;
  singleRef?: boolean;
  maxVisibleRefs?: number;
  backRelationName?: string;
};

// Fast custom schemas — dataSource.cellValueGet runs safeParse on EVERY
// cell.value$ read. A deep zod.object schema creates ParseInputLazyPath
// instances per field per cell, which under signal-cascade re-renders
// produces ms-scale GC pressure that hangs Chrome. Custom predicates skip
// Zod's internal walk.
export const RelationRawValueSchema = zod.custom<RelationRawValue>(v =>
  Array.isArray(v)
);
export const RelationPropertySchema = zod.custom<RelationPropertyData>(
  v => typeof v === 'object' && v !== null
);
// Kept for round-trip toJson/fromJson use; not on the hot path.
export const RelationRefSchema = zod.custom<RelationRef>(
  v => typeof v === 'object' && v !== null
);

export const RELATION_PROPERTY_TYPE = 'orghub-relation' as const;

export const dedupeRefs = (refs: RelationRawValue): RelationRawValue => {
  const seen = new Set<string>();
  const out: RelationRawValue = [];
  for (const ref of refs) {
    const key = `${ref.docId}::${ref.blockId}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(ref);
  }
  return out;
};
